import { render } from "./BankInfo.vue?vue&type=template&id=6b407806&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=js"
export * from "./BankInfo.vue?vue&type=script&lang=js"

import "./BankInfo.vue?vue&type=style&index=0&id=6b407806&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b407806"]])

export default __exports__